module.exports = __webpack_public_path__ + "static/media/993834.a838f57f.png";